<template>
    <Layout>
        <div class="row mt-2">
            <div class="col-12">
                <h6 class="page-title font-18">:: {{ trainee.name }} ::</h6>
            </div>
        </div>
        <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(trainee).length !== 0">
            <div class="row">
                <div class="col-md-9 col-sm-9 col-lg-9">
                    <div class="row pb-2">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                                <strong class="d-block text-dark pb-1">EP Type</strong>
                                {{ trainee.ep_type.desc }}
                            </p>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Form Number</strong>
                                {{ trainee.form_no }}
                            </p>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Mobile Number</strong>
                                    {{ trainee.mobile }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row pb-2">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Mobile Number(Family)</strong>
                                    {{ trainee.mobile_alt }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">
                                        <span v-if="trainee.id_type == 'N'">National ID</span>
                                        <span v-if="trainee.id_type == 'P'">Passport No.</span>
                                        <span v-if="trainee.id_type == 'B'">Birth Certificate No.</span>
                                    </strong>
                                    {{ trainee.nid }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                                <strong class="d-block text-dark pb-1">1.0 Household Number</strong>
                                {{ trainee.household_number }}
                            </p>
                        </div>
                    </div>
                    <div class="row pb-2">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">1.2 Name Household Head</strong>
                                {{ trainee.name }}
                            </p>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">
                                        <span v-if="trainee.father_hus_type == 'F'">1.3 Fathers Name</span>
                                        <span v-if="trainee.father_hus_type == 'H'">1.3 Husband Name</span>
                                        <span v-if="trainee.father_hus_type == 'S'">1.3 Spouse Name</span>
                                    </strong>
                                    {{ trainee.father_husband_name }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                                    <strong class="d-block text-dark pb-1">Loss Types</strong>
                                    <span v-for="(loss_type, index) in trainee.loss_types" :key="index">
                                        {{ loss_type.desc }}{{ index + 1 !== trainee.loss_types.length ? " |" : "" }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row pb-2">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.4 Mothers Name</strong>
                                    {{ trainee.mother_name }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                                <strong class="d-block text-dark pb-1">1.5 Date Of Birth</strong>
                                {{ trainee.dob }}
                            </p>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">1.6 Gender</strong>
                                {{ trainee.gender.desc }}
                            </p>
                        </div>
                    </div>
                    <div class="row pb-2">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.7 Religion</strong>
                                    <span v-if="trainee.religion">{{ trainee.religion.desc }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.8 Education</strong>
                                    <span v-if="trainee.education">{{ trainee.education.desc }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                                <strong class="d-block text-dark pb-1">1.9 Marital Status</strong>
                                <span v-if="trainee.maritial_status">{{ trainee.maritial_status.desc }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="row pb-2">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">1.10 Main Occupation</strong>
                                <span v-if="trainee.occupation">{{ trainee.occupation.desc }}</span>
                            </p>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.11 Village</strong>
                                    <span v-if="trainee.village">{{ trainee.village.desc }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150 black strong">
                                <strong class="d-block text-dark pb-1">1.12 Mouza</strong>
                                <span v-if="trainee.mouza">{{ trainee.mouza.desc }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.13 Union/Ward</strong>
                                    <span v-if="trainee.union">{{ trainee.union.desc }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">1.14 Upazila</strong>
                                <span v-if="trainee.upazila">{{ trainee.upazila.desc }}</span>
                            </p>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.15 District</strong>
                                    <span v-if="trainee.district">{{ trainee.district.desc }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.16 Yearly Income</strong>
                                    {{ trainee.yearly_income }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.17 Affected Land Plots</strong>
                                    {{ trainee.affected_plots }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Affected and Khatians</strong>
                                    {{ trainee.affected_khatians }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Affected Land Mouzas</strong>
                                    {{ trainee.affected_mouzas }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.18 Present Address</strong>
                                    {{ trainee.address }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Permanent Address</strong>
                                    {{ trainee.permanent_address }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.19 Received any Training before?</strong>
                                    <span v-if="trainee.previous_training == 1">Yes</span>
                                    <span v-if="trainee.previous_training == 0">No</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.20 Training Trades & Duration</strong>
                                    {{ trainee.previous_training_duration }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.21 Any specific Skills</strong>
                                    {{ trainee.specific_skills }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">1.22 Driving License Information</strong>
                                    <span v-if="trainee.c_driving_license_id == 1">Learner</span>
                                    <span v-if="trainee.c_driving_license_id == 2">Finger Print</span>
                                    <span v-if="trainee.c_driving_license_id == 3">License Available</span>
                                    <span v-if="trainee.c_driving_license_id == 4">NA</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Are you Household head?</strong>
                                    <span v-if="trainee.is_household_head == 1">Yes</span>
                                    <span v-if="trainee.is_household_head != 1">No</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                    <template v-for="image in trainee.files">
                        <span v-if="image.extension != 'pdf'">
                            <a :href="image.name" target="_blank">
                                <img :src="image.name" alt="" class="rounded" height="200px" width="200px" />
                            </a>
                        </span>
                        <p style="margin-top: 3px;font-weight: bold">
                            <span v-if="image.category_id == '3'">Photo: Household head</span>
                            <span v-if="image.category_id == '2'">Photo: Trainee</span>
                        </p>

                        <span v-if="image.extension == 'pdf'">
                            <a :href="image.name" target="_blank" class="btn btn-sm btn-info">{{ image.caption }} File</a>
                        </span>
                    </template>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12 mb-2">
                    <h4>Field Book Info</h4>
                </div>
                <div class="col-md-12">
                    <table class="table table-centered table-striped">
                        <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Field Book</th>
                                <th>Book Sub no.</th>
                                <th>Name Bn</th>
                                <th>Father`s Name Bn</th>
                                <th>Village</th>
                                <th>Mouza</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(field_book, index) in trainee.field_books" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ field_book.field_book_no }}</td>
                                <td>{{ field_book.filed_book_sub_no }}</td>
                                <td>{{ field_book.name_bn }}</td>
                                <td>{{ field_book.father_name_bn }}</td>
                                <td>{{ field_book.village ? field_book.village.desc : '' }} </td>
                                <td>{{ field_book.mouza ? field_book.mouza.desc : '' }} </td>
                                <td>
                                    <span class="custom-label custom-label-danger"
                                        v-if="field_book.status_id == 1">Locked</span>
                                    <span v-if="field_book.status_id == 2">Unlock</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
            <div class="mt-3 bg-gray" v-if="trainee.is_representative == 1">
                <h4>2.0 Representative Info</h4>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.1 Name of Representative/Trainee</strong>
                                {{ trainee.rep_name }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.2 Relation With HH</strong>
                                {{ trainee.family_relation ? trainee.family_relation.desc : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">
                                    <span v-if="trainee.rep_father_hus_type === 'F'">2.3 Fathers Name</span>
                                    <span v-if="trainee.rep_father_hus_type === 'H'">2.3 Husband Name</span>
                                    <span v-if="trainee.rep_father_hus_type === 'S'">2.3 Spouse Name</span>
                                </strong>
                                {{ trainee.rep_father_husband_name }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.4 Mothers Name</strong>
                                {{ trainee.rep_mother_name }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.5 Date Of Birth</strong>
                                {{ trainee.rep_dob }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.6 Gender</strong>
                                {{ trainee.rep_gender ? trainee.rep_gender.desc : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.7 Main Occupation</strong>
                                {{ trainee.rep_occupation ? trainee.rep_occupation.desc : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.8 Religion</strong>
                                {{ trainee.rep_religion ? trainee.rep_religion.desc : '' }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.9 Education</strong>
                                {{ trainee.rep_education ? trainee.rep_education.desc : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.10 Marital Status</strong>
                                {{ trainee.rep_maritial_tatus ? trainee.rep_maritial_tatus.desc : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">2.11 Present Address</strong>
                                {{ trainee.rep_address }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Permanent Address</strong>
                                {{ trainee.rep_permanent_address }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">
                                    <span v-if="trainee.rep_id_type === 'N'">2.12 National ID</span>
                                    <span v-if="trainee.rep_id_type === 'P'">2.12 Passport No.</span>
                                    <span v-if="trainee.rep_id_type === 'B'">2.12 Birth Certificate No.</span>
                                </strong>
                                {{ trainee.rep_nid }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Mobile Number</strong>
                                {{ trainee.rep_mobile }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Mobile Number(Family)</strong>
                                {{ trainee.rep_mobile_alt }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 col-sm-6 col-lg-3">
                    <div class="media text-muted">
                        <p class="media-body pb-2 mb-0 medium lh-150">
                            <strong class="d-block text-dark pb-1">3.0 Preferred Training Trades</strong>
                            <span v-bind:key="index" v-for="(trade, index) in trainee.trades">{{ trade.desc }}
                                {{ index + 1 !== trainee.trades.length ? " ," : "" }}</span>
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                    <div class="media text-muted">
                        <p class="media-body pb-2 mb-0 medium lh-150">
                            <strong class="d-block text-dark pb-1">4.0 Preferred Training Time</strong>
                            {{ this.trainee.pref_time.desc }}
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                    <div class="media text-muted">
                        <p class="media-body pb-2 mb-0 medium lh-150">
                            <strong class="d-block text-dark pb-1">Survey Conducted By</strong>
                            {{ trainee.survey_worker ? trainee.survey_worker.name : '' }}
                        </p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-lg-3">
                    <div class="media text-muted">
                        <p class="media-body pb-2 mb-0 medium lh-150">
                            <strong class="d-block text-dark pb-1">Survey Date</strong>
                            {{ trainee.survey_conducted_date ? trainee.survey_conducted_date : '' }}
                        </p>
                    </div>
                </div>
            </div>

            <!--            <span v-if="trainee.c_training_trade_id === 1"><ComputerBasic :trainee_id="trainee.id"></ComputerBasic></span>-->
            <!--            <span v-if="trainee.c_training_trade_id === 2"><MansionWork :trainee_id="trainee.id"></MansionWork></span>-->
            <TraineeFollowup :trainee_id="trainee.id"></TraineeFollowup>

        </div>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import ComputerBasic from "../trainee/followup/trainee-view/computer-basic"
import MansionWork from "../trainee/followup/trainee-view/mansion-work"
import TraineeFollowup from "../trainee/followup/general/trainee-followup-view"

export default {
    page: {
        title: "View Trainee",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, ComputerBasic, MansionWork, TraineeFollowup },
    data() {
        return {
            title: "View Trainee",
            items: [
                {
                    text: "Training",
                    href: "/"
                },
                {
                    text: "Dashboard",
                    active: true
                }
            ],

            trainee: {},
        };
    },

    mounted() {
        this.getTrainee();
    },
    methods: {
        getTrainee() {
            let trainee_id = this.$route.params.trainee_id;

            http.get("api/trainees/" + trainee_id).then(response => {
                if (!response.data.error) {
                    this.trainee = response.data.trainee;
                    //console.log(this.trainee)
                }
            });
        },
    },

};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
    -webkit-appearance: unset;
}

.vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
}

.multiselect__tags {
    border-color: #ced4da;
    border-radius: 3px;
    min-height: 30px;
    padding: 4px 25px 0px 10px;
    margin-bottom: 0;
}

.multiselect__tag {
    margin-bottom: 0px;
}

.multiselect__placeholder {
    margin-bottom: 0px;
}

.multiselect__select {
    height: 30px;
}

.custom-select {
    color: #6c757d !important;
}
</style>
